module.exports = "data:text/x-markdown;base64,CkluIHRoaXMgYFRpbWVBeGlzYCBleGFtcGxlIHdlIGNyZWF0ZSBhIG5ldyBheGlzIGZyb20gYSBgYmVnaW5UaW1lYCBhbmQgYGVuZFRpbWVgIGFuZCBzcGVjaWZ5IHRoZSBkaWZmZXJlbnQgZm9ybWF0cyBzdWNoIGFzIGB5ZWFyYCwgYG1vbnRoYCwgYGRheWAgYW5kIGBob3VyYC4KCkJvdGggYGJlZ2luVGltZWAgYW5kIGBlbmRUaW1lYCBhcmUgcmVndWxhciBKYXZhc2NyaXB0IERhdGVzLgoKYGBganMKICAgIDxUaW1lQXhpcwogICAgICAgIGZvcm1hdD0iaG91ciIKICAgICAgICBwb3NpdGlvbj0iYm90dG9tIgogICAgICAgIGJlZ2luVGltZT17YmVnaW5UaW1lfQogICAgICAgIGVuZFRpbWU9e2VuZFRpbWV9CiAgICAgICAgd2lkdGg9ezgwMH0KICAgICAgICBoZWlnaHQ9ezUwfSAvPgpgYGAKCg=="


//////////////////
// WEBPACK FOOTER
// ./src/website/examples/format/format_docs.md
// module id = 436
// module chunks = 0